// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  version: '1.3.0',
  versionName: 'Ahoy',
  commitHash: '59eb360',
  production: false,
  sentryDsn: 'https://e7924aa6d4e360ee9d11029ebe514a8f@o449251.ingest.us.sentry.io/4506932195229696',
  stage: 'dev',
  firebase: {
    apiKey: 'AIzaSyCoSALX2fUD54wPpHX2iaZqsP9B9X6zzjQ',
    authDomain: 'speakseemvp.firebaseapp.com',
    databaseURL: 'https://speakseemvp.firebaseio.com',
    projectId: 'speakseemvp',
    storageBucket: 'speakseemvp.appspot.com',
    messagingSenderId: '353492585696',
    appId: '1:353492585696:web:6764e53e672bc07ce314',
    documentName: 'Hub1-qa-master',
  },
  speaksee: {
    releaseNumber: 'dev',
    authUrl: 'https://authenticate-dev.speaksee.ai',
    apiUrl: 'https://api-dev.speaksee.ai',
    mySpeaksee: 'https://my.speaksee.ai',
    websocketUrl: 'wss://ws-proxy-dev.speaksee.ai/ws-new',
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
